import { render } from "./ListImportUnsub.vue?vue&type=template&id=22040648&scoped=true"
import script from "./ListImportUnsub.vue?vue&type=script&lang=ts"
export * from "./ListImportUnsub.vue?vue&type=script&lang=ts"

import "./ListImportUnsub.vue?vue&type=style&index=0&id=22040648&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-22040648"

export default script